import React from 'react'
import GraciasComponent from '../components/Gracias/GraciasComponent'

const Gracias = () => {
  return (
    <GraciasComponent />
  )
}

export default Gracias